import React from "react";
import styled from "styled-components/macro";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { Sliders } from "react-feather";

import { getAppConfig, getItemFilter, getLanguage } from "../../../store/sagas/selectors";

interface IsMobileProps {
    isMobile?: Boolean;
}

const MenuFilterContainer = styled.div<IsMobileProps>`
    float: left;
    margin-left: 5px;
    display: flex;
    align-items: center;
`;

const MobileMenuFilterIcon = styled.div`
    color: ${props => props.theme.textColorSecondary};
    height: 20px;
    float: left;
    display: flex;
    align-items: center;
    svg {
        transform: rotate(90deg);
    }
`;

const MenuFilterText = styled.div`
    color: ${props => props.theme.textColorSecondary};
    font-size: 13px;
    font-family: ${props => props.theme.fontFamily};
    margin: 0 3px;
    float: left;
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
`;

const FilterIndicator = styled.div`
    background: ${props => props.theme.buttonNext.backgroundColor};
    color: white;
    border-radius: 50px;
    width: fit-content;
    float: right;
    padding: 4px;
    font-size: 12px;
    margin-left: 2px;
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
`;

const Container = styled.div<IsMobileProps>`
    ${props => (props.isMobile ? `height: 30px;` : `height: 32px;`)};
    display: flex;
    align-items: center;
    margin-right: ${props => (props.isMobile ? `0px` : `10px`)};
    cursor: pointer;
    user-select: none;
    width: fit-content;
    transition: background-color 0.2s ease-in-out;
    border-radius: 5px;
    padding-right: 5px;

    @media (hover) {
        &:hover {
            ${props => `background-color:${props.theme.filter.chips.hoverColor}`};
        }
        &.active {
            ${props => `background-color: rgba(242, 242, 242, 1)`};
            &:hover {
                ${props => `background-color:${props.theme.filter.chips.hoverColor}`};
            }
        }
    }
`;

const NumberFilterContainer = styled.div`
    float: right;
`;

export const MenuFilter = ({
    toggleFilters,
    shouldShowFilters,
    isMobile,
    hideLabel,
}: {
    toggleFilters: Function;
    shouldShowFilters: boolean;
    isMobile: boolean;
    hideLabel?: boolean;
}) => {
    const appConfig = useSelector(getAppConfig);
    const language = useSelector(getLanguage);
    const itemFilter = useSelector(getItemFilter);

    const numActiveFilterValues = itemFilter.numActiveFilterValues();
    return (
        <Container className={shouldShowFilters ? "active" : ""} isMobile={isMobile} onClick={() => toggleFilters()}>
            <MenuFilterContainer isMobile={isMobile}>
                <>
                    <MobileMenuFilterIcon>
                        <Sliders size={15} />
                    </MobileMenuFilterIcon>
                    <MenuFilterText>
                        {!hideLabel ? get(appConfig, `translations.${language}.filterButton`, "filterButton") : null}
                    </MenuFilterText>
                    <NumberFilterContainer>
                        {numActiveFilterValues > 0 && isMobile ? <FilterIndicator /> : <></>}
                    </NumberFilterContainer>
                </>
            </MenuFilterContainer>
        </Container>
    );
};
